import { Box, Heading } from '@zillow/constellation-10';

import { PartialMessage } from '@zg-rentals/backend-styled-components';

import type {
  RentalManagerSupportHelpArticleResponseDto,
  RentalManagerSupportHelpArticlesResponseDto,
} from '@zg-rentals/ts-rental-manager-api-client';
import { StyledAnchor } from './styles';
interface HelpArticlesContentProps {
  data: RentalManagerSupportHelpArticlesResponseDto;
  error: boolean;
}

export const HelpArticlesContent = ({ data, error }: HelpArticlesContentProps) => {
  //  if there is an error just don't show the articles section
  if (error || !data) return null;

  const renderHelpArticle = (helpArticle: RentalManagerSupportHelpArticleResponseDto) => {
    const { title, contents } = helpArticle;

    return (
      <>
        <Box css={{ marginBottom: '200' }}>
          <PartialMessage partialMessages={title} linkComponent={StyledAnchor} fontType="body-sm" />
        </Box>
        {contents?.length > 0 && (
          <Box css={{ marginBottom: '600' }}>
            {contents?.map((content) => {
              const key = content.reduce((prevText, textDto) => textDto.text + prevText, '');
              return (
                <PartialMessage
                  key={`help-article-contents-${key}`}
                  partialMessages={content}
                  linkComponent={StyledAnchor}
                  fontType="body-sm"
                />
              );
            })}
          </Box>
        )}
      </>
    );
  };

  return (
    <Box css={{ marginLeft: { base: 0, xl: '1200' }, marginTop: { base: '800', xl: 0 } }} data-testid="HelpArticles">
      {data?.heading && (
        <Heading css={{ marginBottom: '600' }} level={6}>
          {data?.heading}
        </Heading>
      )}
      {data?.helpArticles?.map((helpArticle: RentalManagerSupportHelpArticleResponseDto) => {
        return (
          <div key={`help-article-${helpArticle.title[0].url || helpArticle.title[0].text}`}>
            {renderHelpArticle(helpArticle)}
          </div>
        );
      })}
    </Box>
  );
};
